<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" small icon v-on="on">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Edit Supplier {{ item.name }}</span>
      </v-card-title>
      <v-card-text>
        <v-alert type="error" v-if="errorMessage">
          <span v-html="errorMessage"></span>
        </v-alert>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Name"
                v-model="item.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Country"
                v-model="item.country"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Currency"
                v-model="item.currency"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                type="number"
                label="Exchange Rate"
                v-model="item.exchangeRate"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="item.allowAsyncRequests"
                label="Allow asynchronous requests"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="item.delayToRequest"
                label="Add delay to requests"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <h3>API Parameters</h3>
              <v-divider></v-divider>
              <v-container class="pa-0">
                <v-row>
                  <v-col cols="12" md="6" v-for="(element, key) in item.parameters" :key="key">
                    <v-text-field
                      :label="key"
                      v-model="item.parameters[key]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" text :loading="loading" @click="updateItem">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['item'],
  data: () => ({
    dialog: false,
    loading: false,
    errorMessage: ''
  }),
  methods: {
    updateItem () {
      this.loading = true
      this.errorMessage = ''
      this.$http.patch(this.item['@id'],
        {
          name: this.item.name,
          country: this.item.country,
          currency: this.item.currency,
          exchangeRate: parseFloat(this.item.exchangeRate),
          allowAsyncRequests: this.item.allowAsyncRequests,
          delayToRequest: this.item.delayToRequest,
          parameters: this.item.parameters
        },
        {
          headers: { 'Content-Type': 'application/merge-patch+json' }
        }
      )
        .then(() => {
          this.dialog = false
          this.$emit('refresh')
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
